import createIcon from '../../createIcon';

/**
 * @component @name BorderBottom
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAxMUg3VjEzSDlWMTFaTTEzIDE1SDExVjE3SDEzVjE1Wk05IDNIN1Y1SDlWM1pNMTMgMTFIMTFWMTNIMTNWMTFaTTUgM0gzVjVINVYzWk0xMyA3SDExVjlIMTNWN1pNMTcgMTFIMTVWMTNIMTdWMTFaTTEzIDNIMTFWNUgxM1YzWk0xNyAzSDE1VjVIMTdWM1pNMTkgMTNIMjFWMTFIMTlWMTNaTTE5IDE3SDIxVjE1SDE5VjE3Wk01IDdIM1Y5SDVWN1pNMTkgM1Y1SDIxVjNIMTlaTTE5IDlIMjFWN0gxOVY5Wk01IDExSDNWMTNINVYxMVpNMyAyMUgyMVYxOUgzVjIxWk01IDE1SDNWMTdINVYxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BorderBottom = createIcon('BorderBottom', [
  [
    'path',
    {
      d: 'M9 11H7V13H9V11ZM13 15H11V17H13V15ZM9 3H7V5H9V3ZM13 11H11V13H13V11ZM5 3H3V5H5V3ZM13 7H11V9H13V7ZM17 11H15V13H17V11ZM13 3H11V5H13V3ZM17 3H15V5H17V3ZM19 13H21V11H19V13ZM19 17H21V15H19V17ZM5 7H3V9H5V7ZM19 3V5H21V3H19ZM19 9H21V7H19V9ZM5 11H3V13H5V11ZM3 21H21V19H3V21ZM5 15H3V17H5V15Z',
      key: 'pd6yke',
    },
  ],
]);

export default BorderBottom;
